export default "__VITE_ASSET__BePpafv9__"